import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Blossom from "./pages/Blossom";
import Photography from "./pages/Photography";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import SAS from "./pages/SAS";
import SiriusXM from "./pages/SiriusXM";
import NotFound from "./pages/NotFound";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import Explorations from "./pages/Explorations";
import Arcade from "./pages/Arcade";

const router = createBrowserRouter([
	{
		path: "/",
		element: <App />,
	},
	{
		path: "blossom",
		element: <Blossom />,
	},
	{
		path: "photography",
		element: <Photography />,
	},
	{
		path: "about",
		element: <About />,
	},
	{
		path: "gallery",
		element: <Gallery />,
	},
	{
		path: "sas",
		element: <SAS />,
	},
	{
		path: "siriusxm",
		element: <SiriusXM />,
	},
	{
		path: "arcade",
		element: <Arcade />,
	},
	{
		path: "explorations",
		element: <Explorations />,
	},
	{
		path: "*",
		element: <NotFound />,
	},
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<RouterProvider router={router} />
		<Analytics />
	</React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
